var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#7029a3",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.887 8.3304h10.227c0.8534 0 1.5467 0.69333 1.5467 1.5467v1.7067c0 0.62667-0.3867 1.4-0.7733 1.7867l-3.3334 2.9467c-0.46666 0.38666-0.77333 1.16-0.77333 1.7867v3.3334c0 0.4666-0.30667 1.08-0.69333 1.32l-1.08 0.68c-1.0133 0.6266-2.4-0.08-2.4-1.32v-4.1067c0-0.54667-0.30667-1.24-0.62667-1.6267l-2.9467-3.1067c-0.38667-0.37334-0.69333-1.08-0.69333-1.5467v-1.7733c0-0.93334 0.69333-1.6267 1.5467-1.6267z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/icon_filter.8f92f8312ab0445c5d242875214d5d0d.svg";
export { ForwardRef as ReactComponent };